<template>
  <nav class="navigation navigation--vertical">
    <ul>
      <li v-for="(item, index) in localItems" :key="`${item.name}-${index}`">
        <template v-if="item.items">
          <h4 class="navigation__subtitle" :class="[{ 'navigation__subtitle--collapsible' : item.collapsible !== false }]" @click="collapse(item)" v-if="localItems.length > 1">
            <font-awesome-icon :icon="item.icon" v-if="item.icon " /> {{ item.label }}
            <font-awesome-icon icon="arrow-up" v-if="!item.collapsed" class="navigation__collapse__icon" />
            <font-awesome-icon icon="arrow-down" v-if="item.collapsed" class="navigation__collapse__icon" />
          </h4>
          <navigation :items="item.items" class="navigation__collapsible" :class="[{ 'navigation--collapsed' : item.collapsed }]"></navigation>
        </template>
        <template v-else>
          <router-link :to="{ name: item.name, params: item.params ? item.params : {} }">
            <font-awesome-icon :icon="item.icon" v-if="item.icon " /> {{ item.label }}
          </router-link>
        </template>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'navigation',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localItems: [],
    };
  },
  created() {
    this.localItems = this.prepare(this.decouple(this.items));
  },
  methods: {
    /**
     * Standardize items
     */
    prepare(items) {
      items.forEach(item => {
        if (typeof item.collapsed === 'undefined') {
          item.collapsed = false;
        }
      });
      return items;
    },
    collapse(item) {
      item.collapsed = !item.collapsed;
    },
  },
};
</script>

<style lang="scss">
$border: #eee;

.navigation__element--standard {
  display: block;
}

.navigation {
  ul {
    list-style-type: none;
    padding-left: 0;
    margin: 0;
    font-size: 12px;
    font-weight: 700;
    li {
      a {
        color: $text;
        height: 60px;
        line-height: 60px;
        .svg-inline--fa {
          width: 60px;
          height: 1.5em;
          vertical-align: -0.5em;
        }
        @extend .navigation__element--standard;
        &:hover,
        &.router-link-exact-active {
          text-decoration: none;
          color: $fill-info;
          background-color: $fill-highlight;
        }
      }
    }
  }
}

.navigation__subtitle {
  @extend .navigation__element--standard;
  margin-bottom: 0;
  text-transform: uppercase;
}

.navigation__subtitle--collapsible {
  cursor: pointer;
}

.navigation__collapse__icon {
  float: right;
}

.navigation__collapsible {
  &.navigation--collapsed {
    display: none;
  }
}
</style>
